export default "__VITE_ASSET__BRRsxWfY__"